// components/user/profile/ProfileView.jsx
import React from "react";
import { useSelector } from "react-redux";
import { Card, Button, Tag } from "antd";
import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  EditOutlined,
  CheckCircleOutlined,
  IdcardOutlined,
} from "@ant-design/icons";

const ProfileView = ({ onEdit, isDarkMode }) => {
  const { user } = useSelector((state) => state.profile);

  const InfoItem = ({ icon, label, value, verified }) => (
    <div className="flex items-start gap-3 py-2.5 border-b border-gray-100 dark:border-gray-700 last:border-0">
      <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-gray-50 dark:bg-gray-800">
        {icon}
      </div>
      <div className="flex-1">
        <div
          className={`text-xs ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}
        >
          {label}
        </div>
        <div
          className={`text-sm font-medium flex items-center gap-2 flex-wrap ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
        >
          {value && value !== "null" && value !== "undefined"
            ? value
            : "Not provided"}
          {verified && (
            <Tag
              color="success"
              icon={<CheckCircleOutlined />}
              className="px-2 py-0 text-xs rounded-full"
            >
              Verified
            </Tag>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className="pt-2">
      <Card className="border-0 shadow-sm rounded-xl">
        <div className="flex items-center justify-between pb-3 mb-4 border-b border-gray-100 dark:border-gray-700">
          <h3
            className={`text-sm font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            Personal Information
          </h3>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={onEdit}
            size="small"
            className="bg-green-600 hover:bg-green-700"
          >
            Edit Profile
          </Button>
        </div>

        <InfoItem
          icon={<UserOutlined className="text-sm text-green-500" />}
          label="Full Name"
          value={user?.name}
        />
        <InfoItem
          icon={<MailOutlined className="text-sm text-blue-500" />}
          label="Email Address"
          value={user?.email}
        />
        <InfoItem
          icon={<PhoneOutlined className="text-sm text-purple-500" />}
          label="Mobile Number"
          value={user?.mobile}
          verified={user?.mobile_verified}
        />
        <InfoItem
          icon={<EnvironmentOutlined className="text-sm text-orange-500" />}
          label="Pincode"
          value={user?.pincode}
        />
        <InfoItem
          icon={<IdcardOutlined className="text-sm text-red-500" />}
          label="Address"
          value={user?.address}
        />
      </Card>
    </div>
  );
};

export default ProfileView;
